<i18n>
{
    "en": {},
    "ru": {
        "title": "Карта сайта"
    }
}
</i18n>
<template>
    <div class="page-site-map">
        <PageBlock>
            <Breadcrumb
                :items="breadcrumbs"/>
            <PageBlock
                :big-title="!isDeviceDesktop"
                :title="$t('title')"
                small-header
                content-padding
                content-visible
                class="page-site-map__block"
                :heading-tag="'h1'">

                <ul class="site-map-list site-map-list_catalog">
                    <li
                        class="site-map-list__item">
                        <nuxt-link
                            to="/"
                            class="site-map-list__link">
                            {{ $t('nav.main') }}
                        </nuxt-link>
                    </li>
                    <li
                        v-for="(item, index) in getItems('catalog')"
                        :key="`site-map-item-${index}`"
                        class="site-map-list__item">
                        <nuxt-link
                            :to="get(item, 'url', '/')"
                            class="site-map-list__link">
                            {{ getTranslation(index) }}
                        </nuxt-link>
                    </li>
                </ul>

                <ul class="site-map-list">
                    <li
                        v-for="(item, index) in journalList"
                        :key="`site-map-item-${index}`"
                        class="site-map-list__item">
                        <nuxt-link
                            :to="item.link"
                            class="site-map-list__link">
                            {{ item.name }}
                        </nuxt-link>

                        <ul
                            v-if="get(item, 'innerList', []).length > 0"
                            class="site-map-list site-map-list_inner">
                            <li
                                v-for="(innerItem, innerIndex) in item.innerList"
                                :key="`site-map-item-${innerIndex}`"
                                class="site-map-list__item site-map-list__item_inner">
                                <html-link
                                    :url="innerItem.htmlUrl"
                                    class="site-map-list__link site-map-list__link_inner">
                                    {{ innerItem.name }}
                                </html-link>
                            </li>
                        </ul>

                    </li>
                </ul>

                <ul class="site-map-list">
                    <li
                        v-for="(item, index) in getItems('pages', sortOthers)"
                        :key="`site-map-item-${index}`"
                        class="site-map-list__item">
                        <nuxt-link
                            :to="get(item, 'url', '/')"
                            class="site-map-list__link">
                            {{ getTranslation(index) }}
                        </nuxt-link>
                    </li>
                </ul>

            </PageBlock>
        </PageBlock>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import get from "lodash/get";
import pick from 'lodash/pick'
import PageBlock from '@/components/layout/AppPageBlock'
import Breadcrumb from '@/components/layout/nav/Breadcrumb'
import Section from "@/models/news/Section"
import News from "@/models/catalog/News"
import Articles from "@/models/catalog/Article"

export default {
    name: 'SiteMap',
    components: {
        Breadcrumb,
        PageBlock,
    },
    asyncData({ app, params, error }) {
        const baseUrl = app.i18n.__baseUrl

        const breadcrumbs = [
            {
                path: baseUrl,
                name: app.i18n.t('breadcrumbs.home_page'),
            },
            {
                name: app.i18n.t('breadcrumbs.site_map'),
            }
        ]

        const requests = [
            new Section().custom(new News(), 'sections').get(),
            new Section().custom(new Articles(), 'sections').get()
        ]

        return Promise.all(requests).then((results) => {
            const newsItems = results[0][0].items
            const articlesItems = results[1][0].items
            return {
                breadcrumbs,
                newsItems,
                articlesItems
            }
        }).catch(e => {
            error({statusCode: e.response.status, message: e.response.data});
        });

    },
    data() {
        return {
            newsItems: [],
            articlesItems: [],
            sortOthers: [
                'help',
                'cooperation',
                'about',
                'contacts',
            ],
        }
    },
    computed: {
        ...mapGetters(['isDeviceDesktop']),
        ...mapState(['nav']),
        journalList() {
            const list = [
                {
                    name: this.$t('nav.feed'),
                    link: '/feed/'
                },
                {
                    name: this.$t('nav.news'),
                    link: '/news/',
                    innerList: this.newsItems
                },
                {
                    name: this.$t('nav.library'),
                    link: '/articles/',
                    innerList: this.articlesItems
                },
                // {
                // name: this.$t('nav.video'),
                // link: '/video/'
                // }
            ]
            return list
        },
    },
    mounted() {
        this.loaded = true;
    },
    methods: {
        get,
        getItems(type, sort) {
            const items = this.nav[type] || {};

            if (sort) {
                return pick(items, sort);
            }

            return items;
        },
        getTranslation(key) {
            const navKey = this.isFooter ? 'nav.footer.' : 'nav.'

            return this.$t(navKey + key)
        },
    },
    head(){
        return {
            title: this.$options.filters.metaSitenameTitle(this.$t('title'))
        }
    }
}
</script>

<style lang="less">
.page-site-map {
    .breadcrumb {
        margin-bottom: rem(4);
    }

    &__block {
        @{desktop} & {
            padding-top: rem(16);

            .page-block__content {
                display: grid;
                grid-template-columns: 58% 27% 15%;

                padding-top: rem(19);
            }
        }
    }
}

.site-map-list {
    list-style: none;

    margin: 0;
    padding: 0;

    &:not(:last-of-type) {
        margin-bottom: rem(32);
    }

    &__item {
        font-size: rem(18);
        font-weight: 500;

        &_inner {
            font-weight: 400;
        }
    }

    &__link {
        display: block;

        color: @color-black;
        line-height: rem(27);

        height: 100%;
        width: 100%;

        position: relative;

        transition: color .15s ease;

        .hover({
            color: @color-primary;
        });

        &_inner {
            color: @color-gray;

            &:after {
                background-color: @color-gray;
            }
        }
    }

    &__item:not(:last-of-type) &__link {
        padding-bottom: rem(12);

        & + .site-map-list_inner {
            padding-top: 0;
        }
    }

    &_inner {
        padding-top: rem(12);
    }

    &_catalog {
        padding-top: rem(3);

        @{desktop} & {
            display: flex;
            flex-flow: column wrap;

            margin-bottom: 0;
            padding-top: 0;

            max-height: rem(320);

            .site-map-list__item {
                min-width: rem(124);
            }
        }
    }
}
</style>
